import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { MenuManagementExecutionService } from '@/services/Execution/MenuManagementExecutionService';

export type MenuManagementExecutionListParams = {
  associate_brand_id: string;
};

export type ExecutionListResponse =
  | {
      // 日時実行
      id: string;
      is_executed: boolean;
      scheduled_date: string; // 202310121111
      created_at: string;
    }
  | {
      // 即時実行
      id: string;
      is_executed: boolean;
      scheduled_date: null;
      created_at: string; // 2023-10-19 16:24:57
    };

export const useMenuManagementExecutionList = async (
  params: MenuManagementExecutionListParams
): Promise<ExecutionListResponse[]> => {
  const menuManagementExecutionService = new MenuManagementExecutionService(
    getClient()
  );
  try {
    return await menuManagementExecutionService.list(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
